import {Injectable} from '@angular/core';
import {SimpleModalService} from '../models/services/simple-modal-service';

@Injectable()
export class ShowTermsOfUseModalService extends SimpleModalService {}
